export function getVariable(key: string, defaultValue: string = ''): string {
  return process.env[key] || defaultValue;
}
